// extracted by mini-css-extract-plugin
export default {"container":"cardContainer_container__QFCDS","shadow":"cardContainer_shadow__TmZc9"};